/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Invite_AInputs */



/**
* | output |
* | --- |
* | "Open the customer and click Send invitation; the link then appears, so you can also copy it and forward it yourself. Links expire after 24 hours. Ask the cus..." |
*
* @param {Partner_Faq_Invite_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_invite_a = /** @type {((inputs?: Partner_Faq_Invite_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Invite_AInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffnen Sie den Kunden und klicken Sie auf „Einladung senden“; danach erscheint der Link, den Sie auch kopieren und selbst weiterleiten können. Links laufen nach 24 Stunden ab. Bitten Sie den Kunden, seinen Spam-Ordner zu prüfen. Der Kunde wird als „Ausstehend“ angezeigt, bis jemand sein Konto eingerichtet hat.")
	return /** @type {LocalizedString} */ ("Open the customer and click Send invitation; the link then appears, so you can also copy it and forward it yourself. Links expire after 24 hours. Ask the customer to check their spam folder. The customer shows as Pending until someone has set up their account.")
});